import { useLocalization } from '@/hooks/useLocalization';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import { INDUSTRY_OPTIONS } from '@/utils/constants';

export default function IndustryScreen() {
  const { t } = useLocalization();
  const { chooseIndustry } = useChat();

  return (
    <BotMessage text={t('industry.message')}>
      <ScreenOptions>
        {INDUSTRY_OPTIONS.map(opt => (
          <OptionButton key={opt.value} onClick={() => chooseIndustry(opt.value)}>
            {t(opt.labelKey)}
          </OptionButton>
        ))}
      </ScreenOptions>
    </BotMessage>
  );
}
